import { FC } from 'react';
import { JsonLD } from './json-ld';
import { useFeedTdk } from '../shared/use-feed-tdk';
import { useCategoryData } from '~/models/feed';
import { useAtomValue } from 'jotai';
import { $RootTraffic } from '@lemon8/web-app-shared/atom';
import { Outlet } from '@remix-run/react';
import { $PageLevelTraffic } from 'shared/atoms';

export const FeedHead: FC = () => {
  const { category } = useCategoryData();
  const { enterHref } = useAtomValue($RootTraffic);
  const { canonicalUrl } = useAtomValue($PageLevelTraffic);

  const { title, keywords, description } = useFeedTdk(category);

  return (
    <>
      <title key="title">{title}</title>
      <meta key="keywords" name="keywords" content={keywords} />
      <meta key="description" name="description" content={description} />
      <meta property="og:url" content={enterHref} />
      <meta property="og:type" content="article" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image:type" content="image/jpeg" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content="@sharee" />
      <meta name="twitter:text:title" content={title} />
      <meta name="twitter:description" content={description} />
      <link rel="canonical" href={canonicalUrl} />
      <JsonLD />
      <Outlet context={{ for: 'head' }} />
    </>
  );
};
